<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#1E1E1E"
            text-color="#bfcbd9" active-text-color="#20a0ff" witch unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <div slot="title">
                                <i :class="item.icon"></i>
                                <span slot="title">{{ item.title }}</span>
                            </div>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">{{
                                    threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index"
                                @click="svnClick(subItem.title)">{{ subItem.title }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
        <!------------------------------------------------- 登录对话框 -->
        <el-dialog title="登录" :visible.sync="loginDialogVisible" width="45%" :close-on-click-modal="false"
            @keyup.enter.native="svnLogin('loginForm')" @close="loginDialogClosed">
            <el-form v-loading="loginLoad" element-loading-text="登录中" element-loading-spinner="el-icon-loading"
                :model="loginForm" ref="loginForm" :rules="loginRole" label-width="80px">
                <el-form-item label="用户名" prop="j_username">
                    <el-input v-model="loginForm.j_username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="j_password">
                    <el-input v-model="loginForm.j_password" type="password" show-password></el-input>
                </el-form-item>
                <div style="margin-left: 80px;">
                    <el-checkbox v-model="loginForm.password_check">记住密码</el-checkbox>
                    <span style="margin-left: 80px; color: #E6A23C; font-size: 12px">注意：服务重启后需要等待1-2分钟</span>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="loginDialogVisible = false">取 消</el-button>
                <el-button type="primary" slot="append" @click="svnLogin('loginForm')" :disabled="loginLoad">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import bus from '../common/bus';
import { svnLogin, svnLoginStatus } from '../api/svnAPI.js';
import { localStg } from '@/utils/storage/local';
import { PermissionMenu } from '@/constant/menu/menu';
import { deepCopy } from '@/utils/object';

export default {
    data() {
        return {
            collapse: false,
            leftMenuFlag: [],
            //持久化数据
            items: [],

            //登录对话框
            loginDialogVisible: false,
            loginLoad: false,
            //登录对话框
            loginForm: {
                j_username: '',
                j_password: '',
                password_check: false, //记住密码
                url: ''
            },
            loginRole: {
                j_username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                j_password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
        };
    },
    computed: {
        onRoutes() {
            // console.log(this.$route.path.replace('/', ''));
            // return this.$route.path.replace('/', '');
            return this.$route.path
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });

        //刷新左侧菜单
        bus.$on('leftMenu', leftMenuFlag => {
            this.leftMenuFlag = leftMenuFlag
            //刷新可显示菜单
            this.initMenu()
        })
        //刷新可显示菜单
        this.initMenu()
        //SvnEdge操作后 更新登录状态
        bus.$on('refSvnLeftMenu', this.getLoginStatus)
    },
    mounted() {
        //获取 svn登录状态
        this.getLoginStatus()
    },
    activated() {
        //刷新可显示菜单
        this.initMenu()
    },
    methods: {
        async getMenuByRole(roleList) {
            let permissionMenu = deepCopy(PermissionMenu);
            let menuList = []
            roleList.forEach((role, roleIndex) => {
                permissionMenu[role].forEach((menu, index) => {
                    menuList.push(menu)
                })
            })
            return menuList
        },
        async uniqueMenu(menuList) {
            let menuListTemp = []
            let menuTitleSet = new Set()
            for (let i = 0; i < menuList.length; i++) {
                let firstMenu = deepCopy(menuList[i])
                firstMenu.subs = []
                if (menuTitleSet.has(firstMenu.title)) {
                    continue
                }
                menuTitleSet.add(firstMenu.title)
                let subTitleSet = new Set()
                if (menuList[i].subs) {
                    menuList[i].subs.forEach(sub => {
                        if (!subTitleSet.has(sub.title)) {
                            subTitleSet.add(sub.title)
                            firstMenu.subs.push(sub)
                        }
                    })
                }
                for (let j = 0; j < menuList.length; j++) {
                    if (firstMenu.title === menuList[j].title) {
                        // 将menuList[j]的子菜单加入
                        if (menuList[j].subs) {
                            menuList[j].subs.forEach(sub => {
                                if (!subTitleSet.has(sub.title)) {
                                    subTitleSet.add(sub.title)
                                    firstMenu.subs.push(sub)
                                }
                            })
                        }
                    }
                }
                menuListTemp.push(firstMenu)
            }
            return menuListTemp
        },
        async initMenu() {
            // 1. 获取用户权限
            let roleList = localStg.get("roleList");
            if (roleList == null || roleList.length === 0) {
                this.items = PermissionMenu['defaultUser']
                return
            }
            
            if (roleList.includes('超级管理员')) {
                this.items = PermissionMenu['超级管理员']
                return
            }
            // // 2. 根据用户权限获取对应的菜单
            let menuList = await this.getMenuByRole(roleList)
            // // 3. 菜单去重
            this.items = await this.uniqueMenu(JSON.parse(JSON.stringify(menuList)))
        },
    
        //检测 SVN 是否登录   //svnRole   1.超级管理    2.普通用户   3.系统管理   4.版本库管理   5.Repository管理    6.用户管理
        getLoginStatus(svnRole) {
            //未获取到 状态 前清空svn相关下的菜单
            this.items.forEach(item => {
                if (item.title.indexOf('SVN相关') !== -1) {
                    item.subs = [{ index: 'svnStatus', title: 'SVN状态' }, { title: '确认身份中...' }]
                }
            })

            let sessId = localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
            let serviceUrl = localStorage.getItem(localStorage.getItem('ms_username') + 'ServiceUrl')
            //查看登录状态
            let params = { 'url': serviceUrl, 'sessId': sessId }
            let loginStatus = '' //登录状态
            //发送请求
            localStorage.setItem('svnRole', '获取异常')
            svnLoginStatus(params).then(res => {
                if (res.data.code === 200) {
                    loginStatus = '已登录'
                    svnRole = res.data.data.svnRole
                    localStorage.setItem('svnRole', svnRole)

                } else if (res.data.code === 777) {
                    loginStatus = '未登录'
                    localStorage.setItem('svnRole', '未登录')
                } else {
                    loginStatus = '异常'
                }

                //更新左侧菜单
                this.updateLeftItems(loginStatus, svnRole)

            }).catch(err => {
                loginStatus = '异常'
                //更新左侧菜单
                this.updateLeftItems(loginStatus)
            })
        },

        //根据 svn 更新左侧菜单
        updateLeftItems(loginStatus, svnRole) {
            // Svn相关 追加 （登录 或 未登录）
            this.items.forEach(item => {
                if (item.title.indexOf('SVN相关') !== -1) {
                    item.subs = [{ index: 'svnStatus', title: 'SVN状态' }]

                    //未登录 异常状态 都显示 未登录
                    if (loginStatus == '未登录' || loginStatus === '异常') {
                        item.subs = item.subs.concat({ title: '未登录' })
                    }

                    //登录后 展示下拉菜单   //svnRole   1.超级管理    2.普通用户   3.系统管理   4.版本库管理   5.Repository管理    6.用户管理
                    if (loginStatus === '已登录') {
                        item.title = 'SVN相关'
                        item.subs = [{ index: 'svnStatus', title: 'SVN状态' }]
                        //判断 svn角色
                        if (svnRole.indexOf('6') !== -1) {    //用户管理
                            item.subs = item.subs.concat([
                                {
                                    index: 'svnManage',
                                    title: '人员管理'
                                },
                                {
                                    index: 'svnInsert',
                                    title: '人员新增'
                                },
                            ])
                        }

                        if (svnRole.indexOf('4') !== -1 && svnRole.indexOf('6') !== -1) {  //版本库管理
                            item.subs = item.subs.concat([
                                {
                                    index: 'svnAuthorization',
                                    title: '访问规则'
                                },
                            ])
                        }
                        if (svnRole === '') {   //超级管理员
                            item.subs = [{ index: 'svnStatus', title: 'SVN状态' }]
                            item.subs = item.subs.concat([
                                {
                                    index: 'svnManage',
                                    title: '人员管理'
                                },
                                {
                                    index: 'svnInsert',
                                    title: '人员新增'
                                },
                                {
                                    index: 'svnAuthorization',
                                    title: '访问规则'
                                },
                                {
                                    index: 'authorizationInfo',
                                    title: '备份信息'
                                },
                            ])
                        }
                        item.subs = item.subs.concat({ index: 'svnEditPersonal', title: '修改个人信息' }, { title: '登出' })
                    }
                }
            })
        },

        //登录Svn
        svnLogin(loginForm) {
            this.$refs[loginForm].validate((valid) => {
                if (valid) {
                    this.loginDialogVisible = true
                    this.loginLoad = true

                    //localStorage.setItem(localStorage.getItem('ms_username') + 'ServiceUrl', remoteServiceUrl)  //localServiceUrl remoteServiceUrl
                    this.loginForm.url = localStorage.getItem(localStorage.getItem('ms_username') + 'ServiceUrl')
                    //发送请求
                    svnLogin(this.loginForm).then(res => {
                        if (res.data.code == 200) {
                            localStorage.setItem(localStorage.getItem('ms_username') + 'sessId', res.data.data.sessId)

                            //svnRole   1.超级管理    2.普通用户   3.系统管理   4.版本库管理   5.Repository管理    6.用户管理
                            this.getLoginStatus('已登录', res.data.data.svnRole)
                            this.loginDialogVisible = false
                            this.$message.success('登录成功')

                            //记住账号
                            localStorage.setItem('svn_j_username', this.loginForm.j_username)
                            //记住密码被选中, 记住当前状态和密码
                            if (this.loginForm.password_check == true) {
                                localStorage.setItem('svn_j_password', this.loginForm.j_password)
                                localStorage.setItem('svn_password_check', this.loginForm.password_check)
                            } else {
                                localStorage.removeItem('svn_j_password')
                                localStorage.removeItem('svn_password_check')
                            }

                        } else if (res.data.code == 705) {
                            this.$message.error(res.data.message)
                        } else {
                            this.$message.error('登录失败, 检查服务是否开启')
                        }
                        this.loginLoad = false
                    }).catch(err => {
                        this.$message.error('登录失败, 检查服务是否开启')
                        this.loginLoad = false
                    })
                }
            })
        },

        //SVN 登录 登出
        svnClick(title) {
            if (title == '未登录') {
                //展示SVN登录框
                this.loginDialogVisible = true
                //将 记住账号展示
                this.loginForm.j_username = localStorage.getItem('svn_j_username')

                //验证 记住密码框是否选中
                let password_check = localStorage.getItem('svn_password_check')
                if (password_check == 'true') {
                    //true, 填充密码框
                    this.loginForm.j_password = localStorage.getItem('svn_j_password')
                    this.loginForm.password_check = true
                } else {
                    //false, 删除本地储存的密码
                    this.loginForm.j_password = ''
                    localStorage.removeItem('svn_j_password')
                    localStorage.removeItem('svn_password_check')
                    this.loginForm.password_check = false
                }
            }

            if (title == '登出') {
                this.$confirm('确定要登出Svn账号么？', '提示', {
                    type: 'warning'
                }).then(() => {
                    //登出 svn, 清空 登录时的身份令牌
                    localStorage.setItem(localStorage.getItem('ms_username') + 'sessId', '')
                    //刷新 svn列
                    this.getLoginStatus('未登录', '')

                    this.$router.push('/dashboard')
                }).catch(err => {
                    this.$router.push('/svnStatus')
                })
            }
        },

        //监听登录框关闭
        loginDialogClosed() {
            this.$refs.loginForm.resetFields()
        },
    }

};
</script>

<style scoped>
/* ------------自己更改BEGEN------------ */
.el-menu {
    border: 0px;
}

.el-menu-item .is-active {
    color: red;
}

/* ------------自己更改END------------ */

.sidebar {

    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}

.sidebar>ul {
    height: 100%;
}
</style>
